export default __webpack_public_path__ + "static/media/1663532439823.0870e326.jpg";